import { useEffect, useMemo, useState } from "react";
import { useParams } from "react-router-dom";
import { routes } from "../../../app/routes";
import { useSelector } from "react-redux";
import { RootState } from "../../../app";
import { UrlService } from "../../../services";
import {
  TopbarSubmenu,
  IconDefinitions,
  TopbarMenuItem,
} from "../../../components";

export const UserTopbar = (props: any) => {
  const params = useParams();
  const returnUrl = UrlService.getQueryParams("returnUrl");
  const id = params["id"] ?? "";


  const tenantId = useSelector((state: RootState) => state.authentication.tenantId);

  const defaultSubmenuItems: TopbarMenuItem[] = useMemo((): TopbarMenuItem[] => {
    const items: TopbarMenuItem[] = [
      {
        label: "Back",
        icon: IconDefinitions.back,
        url: routes.user.index,
      },
      {
        label: "Details",
        icon: IconDefinitions.user,
        url: routes.user.details,
        activeMatch: routes.user.details,
        activeMatchExact: true,
        params: new Map([["id", id]]),
      },
      {
        label: "Access",
        icon: IconDefinitions.lock,
        url: routes.user.access,
        activeMatch: routes.user.access,
        activeMatchExact: true,
        params: new Map([["id", id]]),
      },
    ];

    
      items.push({
        label: "Delete",
        icon: IconDefinitions.trashCan,
        url: routes.user.delete,
        activeMatch: routes.user.delete,
        activeMatchExact: true,
        params: new Map([["id", id]]),
      });
    

    return items;
  }, [id]);

  useEffect(() => {
    const backItem: TopbarMenuItem = {
      label: "Back",
      icon: IconDefinitions.back,
      url: returnUrl ?? "",
    };

    if (returnUrl) {
      setSubmenuItems([backItem, ...defaultSubmenuItems]);
    } else {
      setSubmenuItems(defaultSubmenuItems);
    }
  }, [defaultSubmenuItems, id, returnUrl]);

  const [submenuItems, setSubmenuItems] =
    useState<TopbarMenuItem[]>(defaultSubmenuItems);

  return <TopbarSubmenu className="p-0" items={submenuItems}></TopbarSubmenu>;
};

export default UserTopbar;

